// Generated by scripts/usda-ingredients.mjs from USDA SR28 (public domain). Do not edit by hand.
// U.S. Department of Agriculture, Agricultural Research Service. USDA National Nutrient Database
// for Standard Reference, Release 28. Values per 100 g, raw unless the USDA name says otherwise.
// Entries with `ifct` come from the Indian Food Composition Tables 2017 (NIN), raw, per 100 g.
import type { Ingredient } from '@/domain/nutrition/types';

export const INGREDIENTS = {
  atta: {
    name: 'Whole wheat flour (atta)',
    ndb: '20080',
    usda: 'WHEAT FLOUR,WHOLE-GRAIN',
    water: 10.74,
    kcal: 340,
    proteinG: 13.21,
    fatG: 2.5,
    carbsG: 71.97,
    fibreG: 10.7,
  },
  maida: {
    name: 'Refined wheat flour (maida)',
    ndb: '20081',
    usda: 'WHEAT FLR,WHITE,ALL-PURPOSE,ENR,BLEACHED',
    water: 11.92,
    kcal: 364,
    proteinG: 10.33,
    fatG: 0.98,
    carbsG: 76.31,
    fibreG: 2.7,
  },
  rice: {
    name: 'Rice, white, raw',
    ndb: '20444',
    usda: 'RICE,WHITE,LONG-GRAIN,REG,RAW,UNENR',
    water: 11.62,
    kcal: 365,
    proteinG: 7.13,
    fatG: 0.66,
    carbsG: 79.95,
    fibreG: 1.3,
  },
  poha: {
    name: 'Flattened rice (poha)',
    ndb: '20444',
    usda: 'RICE,WHITE,LONG-GRAIN,REG,RAW,UNENR',
    water: 11.62,
    kcal: 365,
    proteinG: 7.13,
    fatG: 0.66,
    carbsG: 79.95,
    fibreG: 1.3,
    note: 'White rice values; poha is pressed rice.',
  },
  'rice-flour': {
    name: 'Rice flour',
    ndb: '20061',
    usda: 'RICE FLR,WHITE,UNENR',
    water: 11.89,
    kcal: 366,
    proteinG: 5.95,
    fatG: 1.42,
    carbsG: 80.13,
    fibreG: 2.4,
  },
  sooji: {
    name: 'Semolina (sooji)',
    ndb: '20466',
    usda: 'SEMOLINA,UNENRICHED',
    water: 12.67,
    kcal: 360,
    proteinG: 12.68,
    fatG: 1.05,
    carbsG: 72.83,
    fibreG: 3.9,
  },
  besan: {
    name: 'Gram flour (besan)',
    ndb: '16157',
    usda: 'CHICKPEA FLOUR (BESAN)',
    water: 10.28,
    kcal: 387,
    proteinG: 22.39,
    fatG: 6.69,
    carbsG: 57.82,
    fibreG: 10.8,
  },
  sabudana: {
    name: 'Sago (sabudana)',
    ndb: '20068',
    usda: 'TAPIOCA,PEARL,DRY',
    water: 10.99,
    kcal: 358,
    proteinG: 0.19,
    fatG: 0.02,
    carbsG: 88.69,
    fibreG: 0.9,
  },
  bajra: {
    name: 'Pearl millet (bajra)',
    ndb: '20031',
    usda: 'MILLET,RAW',
    water: 8.67,
    kcal: 378,
    proteinG: 11.02,
    fatG: 4.22,
    carbsG: 72.85,
    fibreG: 8.5,
  },
  jowar: {
    name: 'Sorghum (jowar)',
    ndb: '20067',
    usda: 'SORGHUM GRAIN',
    water: 12.4,
    kcal: 329,
    proteinG: 10.62,
    fatG: 3.46,
    carbsG: 72.09,
    fibreG: 6.7,
  },
  'makki-atta': {
    name: 'Maize flour (makki atta)',
    ndb: '20020',
    usda: 'CORNMEAL,WHOLE-GRAIN,YEL',
    water: 10.26,
    kcal: 362,
    proteinG: 8.12,
    fatG: 3.59,
    carbsG: 76.89,
    fibreG: 7.3,
  },
  'kuttu-atta': {
    name: 'Buckwheat flour (kuttu atta)',
    ndb: '20011',
    usda: 'BUCKWHEAT FLR,WHOLE-GROAT',
    water: 11.15,
    kcal: 335,
    proteinG: 12.62,
    fatG: 3.1,
    carbsG: 70.59,
    fibreG: 10,
  },
  oats: {
    name: 'Oats',
    ndb: '08120',
    usda: 'CEREALS,OATS,REG & QUICK,NOT FORT,DRY',
    water: 10.84,
    kcal: 379,
    proteinG: 13.15,
    fatG: 6.52,
    carbsG: 67.7,
    fibreG: 10.1,
  },
  vermicelli: {
    name: 'Vermicelli (seviyan)',
    ndb: '20120',
    usda: 'PASTA,DRY,ENR',
    water: 9.9,
    kcal: 371,
    proteinG: 13.04,
    fatG: 1.51,
    carbsG: 74.67,
    fibreG: 3.2,
    note: 'Dry wheat pasta values.',
  },
  bread: {
    name: 'White bread',
    ndb: '18069',
    usda: 'BREAD,WHITE,COMMLY PREP (INCL SOFT BREAD CRUMBS)',
    water: 36.42,
    kcal: 266,
    proteinG: 8.85,
    fatG: 3.33,
    carbsG: 49.42,
    fibreG: 2.7,
  },
  'toor-dal': {
    name: 'Toor dal (pigeon peas)',
    ndb: '16101',
    usda: 'PIGEON PEAS (RED GM),MATURE SEEDS,RAW',
    water: 10.59,
    kcal: 343,
    proteinG: 21.7,
    fatG: 1.49,
    carbsG: 62.78,
    fibreG: 15,
  },
  'chana-dal': {
    name: 'Chana dal',
    ndb: '16056',
    usda: 'CHICKPEAS (GARBANZO BNS,BENGAL GM),MATURE SEEDS,RAW',
    water: 7.68,
    kcal: 378,
    proteinG: 20.47,
    fatG: 6.04,
    carbsG: 62.95,
    fibreG: 12.2,
    note: 'Chickpea values.',
  },
  'kabuli-chana': {
    name: 'Chickpeas (kabuli chana)',
    ndb: '16056',
    usda: 'CHICKPEAS (GARBANZO BNS,BENGAL GM),MATURE SEEDS,RAW',
    water: 7.68,
    kcal: 378,
    proteinG: 20.47,
    fatG: 6.04,
    carbsG: 62.95,
    fibreG: 12.2,
  },
  rajma: {
    name: 'Kidney beans (rajma)',
    ndb: '16032',
    usda: 'BEANS,KIDNEY,RED,MATURE SEEDS,RAW',
    water: 11.75,
    kcal: 337,
    proteinG: 22.53,
    fatG: 1.06,
    carbsG: 61.29,
    fibreG: 15.2,
  },
  'moong-dal': {
    name: 'Moong dal',
    ndb: '16080',
    usda: 'MUNG BNS,MATURE SEEDS,RAW',
    water: 9.05,
    kcal: 347,
    proteinG: 23.86,
    fatG: 1.15,
    carbsG: 62.62,
    fibreG: 16.3,
  },
  'urad-dal': {
    name: 'Urad dal',
    ndb: '16083',
    usda: 'MUNGO BNS,MATURE SEEDS,RAW',
    water: 10.8,
    kcal: 341,
    proteinG: 25.21,
    fatG: 1.64,
    carbsG: 58.99,
    fibreG: 18.3,
  },
  'masoor-dal': {
    name: 'Masoor dal (lentils)',
    ndb: '16069',
    usda: 'LENTILS,RAW',
    water: 8.26,
    kcal: 352,
    proteinG: 24.63,
    fatG: 1.06,
    carbsG: 63.35,
    fibreG: 10.7,
  },
  'moong-sprouts': {
    name: 'Moong sprouts',
    ndb: '11043',
    usda: 'MUNG BNS,MATURE SEEDS,SPROUTED,RAW',
    water: 90.4,
    kcal: 30,
    proteinG: 3.04,
    fatG: 0.18,
    carbsG: 5.94,
    fibreG: 1.8,
  },
  'soya-chunks': {
    name: 'Soya chunks',
    ndb: '16117',
    usda: 'SOY FLOUR,DEFATTED',
    water: 7.25,
    kcal: 327,
    proteinG: 51.46,
    fatG: 1.22,
    carbsG: 33.92,
    fibreG: 17.5,
    note: 'Defatted soy flour, what soya chunks are made from.',
  },
  peanuts: {
    name: 'Peanuts',
    ndb: '16087',
    usda: 'PEANUTS,ALL TYPES,RAW',
    water: 6.5,
    kcal: 567,
    proteinG: 25.8,
    fatG: 49.24,
    carbsG: 16.13,
    fibreG: 8.5,
  },
  cashews: {
    name: 'Cashews',
    ndb: '12087',
    usda: 'NUTS,CASHEW NUTS,RAW',
    water: 5.2,
    kcal: 553,
    proteinG: 18.22,
    fatG: 43.85,
    carbsG: 30.19,
    fibreG: 3.3,
  },
  almonds: {
    name: 'Almonds',
    ndb: '12061',
    usda: 'ALMONDS',
    water: 4.41,
    kcal: 579,
    proteinG: 21.15,
    fatG: 49.93,
    carbsG: 21.55,
    fibreG: 12.5,
  },
  raisins: {
    name: 'Raisins',
    ndb: '09298',
    usda: 'RAISINS,SEEDLESS',
    water: 15.43,
    kcal: 299,
    proteinG: 3.07,
    fatG: 0.46,
    carbsG: 79.18,
    fibreG: 3.7,
  },
  coconut: {
    name: 'Coconut, fresh',
    ndb: '12104',
    usda: 'COCONUT MEAT,RAW',
    water: 46.99,
    kcal: 354,
    proteinG: 3.33,
    fatG: 33.49,
    carbsG: 15.23,
    fibreG: 9,
  },
  'coconut-dry': {
    name: 'Coconut, dried',
    ndb: '12108',
    usda: 'COCONUT MEAT,DRIED (DESICCATED),NOT SWTND',
    water: 3,
    kcal: 660,
    proteinG: 6.88,
    fatG: 64.53,
    carbsG: 23.65,
    fibreG: 16.3,
  },
  milk: {
    name: 'Milk, whole (cow)',
    ndb: '01077',
    usda: 'MILK,WHL,3.25% MILKFAT,W/ ADDED VITAMIN D',
    water: 88.13,
    kcal: 61,
    proteinG: 3.15,
    fatG: 3.25,
    carbsG: 4.8,
    fibreG: 0,
  },
  'milk-toned': {
    name: 'Milk, toned',
    ndb: '01079',
    usda: 'MILK,RED FAT,FLUID,2% MILKFAT,W/ ADDED VIT A & VITAMIN D',
    water: 89.21,
    kcal: 50,
    proteinG: 3.3,
    fatG: 1.98,
    carbsG: 4.8,
    fibreG: 0,
    note: '2% fat milk values.',
  },
  'milk-buffalo': {
    name: 'Milk, buffalo',
    ndb: '01108',
    usda: 'MILK,INDIAN BUFFALO,FLUID',
    water: 83.39,
    kcal: 97,
    proteinG: 3.75,
    fatG: 6.89,
    carbsG: 5.18,
    fibreG: 0,
  },
  curd: {
    name: 'Curd (dahi)',
    ndb: '01116',
    usda: 'YOGURT,PLN,WHL MILK,8 GRAMS PROT PER 8 OZ',
    water: 87.9,
    kcal: 61,
    proteinG: 3.47,
    fatG: 3.25,
    carbsG: 4.66,
    fibreG: 0,
  },
  paneer: {
    name: 'Paneer',
    ndb: '01229',
    usda: 'CHEESE,WHITE,QUESO BLANCO',
    water: 48.7,
    kcal: 310,
    proteinG: 20.38,
    fatG: 24.31,
    carbsG: 2.53,
    fibreG: 0,
    note: 'Queso blanco values: fresh cheese set with acid, as paneer is.',
  },
  ghee: {
    name: 'Ghee',
    ndb: '01003',
    usda: 'BUTTER OIL,ANHYDROUS',
    water: 0.24,
    kcal: 876,
    proteinG: 0.28,
    fatG: 99.48,
    carbsG: 0,
    fibreG: 0,
  },
  butter: {
    name: 'Butter',
    ndb: '01145',
    usda: 'BUTTER,WITHOUT SALT',
    water: 17.94,
    kcal: 717,
    proteinG: 0.85,
    fatG: 81.11,
    carbsG: 0.06,
    fibreG: 0,
  },
  cream: {
    name: 'Cream',
    ndb: '01053',
    usda: 'CREAM,FLUID,HVY WHIPPING',
    water: 57.81,
    kcal: 340,
    proteinG: 2.84,
    fatG: 36.08,
    carbsG: 2.74,
    fibreG: 0,
  },
  cheese: {
    name: 'Cheese',
    ndb: '01009',
    usda: 'CHEESE,CHEDDAR',
    water: 37.02,
    kcal: 404,
    proteinG: 22.87,
    fatG: 33.31,
    carbsG: 3.09,
    fibreG: 0,
  },
  oil: {
    name: 'Cooking oil',
    ndb: '04669',
    usda: 'USDA CMDTY FD,OIL,VEG,SOYBN,REFINED',
    water: 0,
    kcal: 884,
    proteinG: 0,
    fatG: 100,
    carbsG: 0,
    fibreG: 0,
  },
  'mustard-oil': {
    name: 'Mustard oil',
    ndb: '04583',
    usda: 'OIL,MUSTARD',
    water: 0,
    kcal: 884,
    proteinG: 0,
    fatG: 100,
    carbsG: 0,
    fibreG: 0,
  },
  egg: {
    name: 'Egg',
    ndb: '01123',
    usda: 'EGG,WHL,RAW,FRSH',
    water: 76.15,
    kcal: 143,
    proteinG: 12.56,
    fatG: 9.51,
    carbsG: 0.72,
    fibreG: 0,
  },
  chicken: {
    name: 'Chicken',
    ndb: '05011',
    usda: 'CHICKEN,BROILERS OR FRYERS,MEAT ONLY,RAW',
    water: 75.46,
    kcal: 119,
    proteinG: 21.39,
    fatG: 3.08,
    carbsG: 0,
    fibreG: 0,
  },
  mutton: {
    name: 'Mutton (goat)',
    ndb: '17168',
    usda: 'GOAT,RAW',
    water: 75.84,
    kcal: 109,
    proteinG: 20.6,
    fatG: 2.31,
    carbsG: 0,
    fibreG: 0,
  },
  fish: {
    name: 'Fish (rohu, carp)',
    ndb: '15008',
    usda: 'CARP,RAW',
    water: 76.31,
    kcal: 127,
    proteinG: 17.83,
    fatG: 5.6,
    carbsG: 0,
    fibreG: 0,
  },
  prawns: {
    name: 'Prawns',
    ndb: '15270',
    usda: 'CRUSTACEANS,SHRIMP,RAW (NOT PREVIOUSLY FROZEN)',
    water: 78.45,
    kcal: 85,
    proteinG: 20.1,
    fatG: 0.51,
    carbsG: 0,
    fibreG: 0,
  },
  potato: {
    name: 'Potato',
    ndb: '11352',
    usda: 'POTATOES,FLESH & SKN,RAW',
    water: 79.25,
    kcal: 77,
    proteinG: 2.05,
    fatG: 0.09,
    carbsG: 17.49,
    fibreG: 2.1,
  },
  onion: {
    name: 'Onion',
    ndb: '11282',
    usda: 'ONIONS,RAW',
    water: 89.11,
    kcal: 40,
    proteinG: 1.1,
    fatG: 0.1,
    carbsG: 9.34,
    fibreG: 1.7,
  },
  tomato: {
    name: 'Tomato',
    ndb: '11529',
    usda: 'TOMATOES,RED,RIPE,RAW,YEAR RND AVERAGE',
    water: 94.52,
    kcal: 18,
    proteinG: 0.88,
    fatG: 0.2,
    carbsG: 3.89,
    fibreG: 1.2,
  },
  cauliflower: {
    name: 'Cauliflower',
    ndb: '11135',
    usda: 'CAULIFLOWER,RAW',
    water: 92.07,
    kcal: 25,
    proteinG: 1.92,
    fatG: 0.28,
    carbsG: 4.97,
    fibreG: 2,
  },
  okra: {
    name: 'Okra (bhindi)',
    ndb: '11278',
    usda: 'OKRA,RAW',
    water: 89.58,
    kcal: 33,
    proteinG: 1.93,
    fatG: 0.19,
    carbsG: 7.45,
    fibreG: 3.2,
  },
  brinjal: {
    name: 'Brinjal (baingan)',
    ndb: '11209',
    usda: 'EGGPLANT,RAW',
    water: 92.3,
    kcal: 25,
    proteinG: 0.98,
    fatG: 0.18,
    carbsG: 5.88,
    fibreG: 3,
  },
  spinach: {
    name: 'Spinach (palak)',
    ndb: '11457',
    usda: 'SPINACH,RAW',
    water: 91.4,
    kcal: 23,
    proteinG: 2.86,
    fatG: 0.39,
    carbsG: 3.63,
    fibreG: 2.2,
  },
  peas: {
    name: 'Green peas (matar)',
    ndb: '11304',
    usda: 'PEAS,GREEN,RAW',
    water: 78.86,
    kcal: 81,
    proteinG: 5.42,
    fatG: 0.4,
    carbsG: 14.45,
    fibreG: 5.7,
  },
  carrot: {
    name: 'Carrot',
    ndb: '11124',
    usda: 'CARROTS,RAW',
    water: 88.29,
    kcal: 41,
    proteinG: 0.93,
    fatG: 0.24,
    carbsG: 9.58,
    fibreG: 2.8,
  },
  cabbage: {
    name: 'Cabbage',
    ndb: '11109',
    usda: 'CABBAGE,RAW',
    water: 92.18,
    kcal: 25,
    proteinG: 1.28,
    fatG: 0.1,
    carbsG: 5.8,
    fibreG: 2.5,
  },
  capsicum: {
    name: 'Capsicum',
    ndb: '11333',
    usda: 'PEPPERS,SWT,GRN,RAW',
    water: 93.89,
    kcal: 20,
    proteinG: 0.86,
    fatG: 0.17,
    carbsG: 4.64,
    fibreG: 1.7,
  },
  beans: {
    name: 'French beans',
    ndb: '11052',
    usda: 'BEANS,SNAP,GREEN,RAW',
    water: 90.32,
    kcal: 31,
    proteinG: 1.83,
    fatG: 0.22,
    carbsG: 6.97,
    fibreG: 2.7,
  },
  lauki: {
    name: 'Bottle gourd (lauki)',
    ndb: '11218',
    usda: 'GOURD,WHITE-FLOWERED (CALABASH),RAW',
    water: 95.54,
    kcal: 14,
    proteinG: 0.62,
    fatG: 0.02,
    carbsG: 3.39,
    fibreG: 0.5,
  },
  karela: {
    name: 'Bitter gourd (karela)',
    ndb: '11024',
    usda: 'BALSAM-PEAR (BITTER GOURD),PODS,RAW',
    water: 94.03,
    kcal: 17,
    proteinG: 1,
    fatG: 0.17,
    carbsG: 3.7,
    fibreG: 2.8,
  },
  pumpkin: {
    name: 'Pumpkin',
    ndb: '11422',
    usda: 'PUMPKIN,RAW',
    water: 91.6,
    kcal: 26,
    proteinG: 1,
    fatG: 0.1,
    carbsG: 6.5,
    fibreG: 0.5,
  },
  mushroom: {
    name: 'Mushroom',
    ndb: '11260',
    usda: 'MUSHROOMS,WHITE,RAW',
    water: 92.45,
    kcal: 22,
    proteinG: 3.09,
    fatG: 0.34,
    carbsG: 3.26,
    fibreG: 1,
  },
  cucumber: {
    name: 'Cucumber',
    ndb: '11205',
    usda: 'CUCUMBER,WITH PEEL,RAW',
    water: 95.23,
    kcal: 15,
    proteinG: 0.65,
    fatG: 0.11,
    carbsG: 3.63,
    fibreG: 0.5,
  },
  garlic: {
    name: 'Garlic',
    ndb: '11215',
    usda: 'GARLIC,RAW',
    water: 58.58,
    kcal: 149,
    proteinG: 6.36,
    fatG: 0.5,
    carbsG: 33.06,
    fibreG: 2.1,
  },
  ginger: {
    name: 'Ginger',
    ndb: '11216',
    usda: 'GINGER ROOT,RAW',
    water: 78.89,
    kcal: 80,
    proteinG: 1.82,
    fatG: 0.75,
    carbsG: 17.77,
    fibreG: 2,
  },
  'green-chilli': {
    name: 'Green chilli',
    ndb: '11670',
    usda: 'PEPPERS,HOT CHILI,GRN,RAW',
    water: 87.74,
    kcal: 40,
    proteinG: 2,
    fatG: 0.2,
    carbsG: 9.46,
    fibreG: 1.5,
  },
  coriander: {
    name: 'Coriander leaves',
    ndb: '11165',
    usda: 'CORIANDER (CILANTRO) LEAVES,RAW',
    water: 92.21,
    kcal: 23,
    proteinG: 2.13,
    fatG: 0.52,
    carbsG: 3.67,
    fibreG: 2.8,
  },
  lemon: {
    name: 'Lemon juice',
    ndb: '09152',
    usda: 'LEMON JUICE,RAW',
    water: 92.31,
    kcal: 22,
    proteinG: 0.35,
    fatG: 0.24,
    carbsG: 6.9,
    fibreG: 0.3,
  },
  'sweet-potato': {
    name: 'Sweet potato',
    ndb: '11507',
    usda: 'SWEET POTATO,RAW,UNPREP',
    water: 77.28,
    kcal: 86,
    proteinG: 1.57,
    fatG: 0.05,
    carbsG: 20.12,
    fibreG: 3,
  },
  sarson: {
    name: 'Mustard greens (sarson)',
    ndb: '11270',
    usda: 'MUSTARD GREENS,RAW',
    water: 90.7,
    kcal: 27,
    proteinG: 2.86,
    fatG: 0.42,
    carbsG: 4.67,
    fibreG: 3.2,
  },
  radish: {
    name: 'Radish (mooli)',
    ndb: '11429',
    usda: 'RADISHES,RAW',
    water: 95.27,
    kcal: 16,
    proteinG: 0.68,
    fatG: 0.1,
    carbsG: 3.4,
    fibreG: 1.6,
  },
  corn: {
    name: 'Sweet corn',
    ndb: '11167',
    usda: 'CORN,SWT,YEL,RAW',
    water: 76.05,
    kcal: 86,
    proteinG: 3.27,
    fatG: 1.35,
    carbsG: 18.7,
    fibreG: 2,
  },
  beetroot: {
    name: 'Beetroot',
    ndb: '11080',
    usda: 'BEETS,RAW',
    water: 87.58,
    kcal: 43,
    proteinG: 1.61,
    fatG: 0.17,
    carbsG: 9.56,
    fibreG: 2.8,
  },
  cumin: {
    name: 'Cumin seeds',
    ndb: '02014',
    usda: 'CUMIN SEED',
    water: 8.06,
    kcal: 375,
    proteinG: 17.81,
    fatG: 22.27,
    carbsG: 44.24,
    fibreG: 10.5,
  },
  turmeric: {
    name: 'Turmeric',
    ndb: '02043',
    usda: 'TURMERIC,GROUND',
    water: 12.85,
    kcal: 312,
    proteinG: 9.68,
    fatG: 3.25,
    carbsG: 67.14,
    fibreG: 22.7,
  },
  'chilli-powder': {
    name: 'Chilli powder',
    ndb: '02009',
    usda: 'CHILI POWDER',
    water: 10.75,
    kcal: 282,
    proteinG: 13.46,
    fatG: 14.28,
    carbsG: 49.7,
    fibreG: 34.8,
  },
  'coriander-powder': {
    name: 'Coriander powder',
    ndb: '02013',
    usda: 'CORIANDER SEED',
    water: 8.86,
    kcal: 298,
    proteinG: 12.37,
    fatG: 17.77,
    carbsG: 54.99,
    fibreG: 41.9,
  },
  'methi-seeds': {
    name: 'Fenugreek seeds',
    ndb: '02019',
    usda: 'FENUGREEK SEED',
    water: 8.84,
    kcal: 323,
    proteinG: 23,
    fatG: 6.41,
    carbsG: 58.35,
    fibreG: 24.6,
  },
  sugar: {
    name: 'Sugar',
    ndb: '19335',
    usda: 'SUGARS,GRANULATED',
    water: 0.02,
    kcal: 387,
    proteinG: 0,
    fatG: 0,
    carbsG: 99.98,
    fibreG: 0,
  },
  jaggery: {
    name: 'Jaggery',
    ndb: '19334',
    usda: 'SUGARS,BROWN',
    water: 1.34,
    kcal: 380,
    proteinG: 0.12,
    fatG: 0,
    carbsG: 98.09,
    fibreG: 0,
    note: 'Brown sugar values.',
  },
  tamarind: {
    name: 'Tamarind',
    ndb: '09322',
    usda: 'TAMARINDS,RAW',
    water: 31.4,
    kcal: 239,
    proteinG: 2.8,
    fatG: 0.6,
    carbsG: 62.5,
    fibreG: 5.1,
  },
  tea: {
    name: 'Tea, brewed',
    ndb: '14355',
    usda: 'BEVERAGES,TEA,BLACK,BREWED,PREP W/ TAP H2O',
    water: 99.7,
    kcal: 1,
    proteinG: 0,
    fatG: 0,
    carbsG: 0.3,
    fibreG: 0,
  },
  coffee: {
    name: 'Coffee, brewed',
    ndb: '14209',
    usda: 'BEVERAGES,COFFEE,BREWED,PREP W/ TAP H2O',
    water: 99.39,
    kcal: 1,
    proteinG: 0.12,
    fatG: 0.02,
    carbsG: 0,
    fibreG: 0,
  },
  'coffee-powder': {
    name: 'Instant coffee powder',
    ndb: '14214',
    usda: 'BEVERAGES,COFFEE,INST,REG,PDR',
    water: 3.1,
    kcal: 353,
    proteinG: 12.2,
    fatG: 0.5,
    carbsG: 75.4,
    fibreG: 0,
  },
  banana: {
    name: 'Banana',
    ndb: '09040',
    usda: 'BANANAS,RAW',
    water: 74.91,
    kcal: 89,
    proteinG: 1.09,
    fatG: 0.33,
    carbsG: 22.84,
    fibreG: 2.6,
  },
  apple: {
    name: 'Apple',
    ndb: '09003',
    usda: 'APPLES,RAW,WITH SKIN',
    water: 85.56,
    kcal: 52,
    proteinG: 0.26,
    fatG: 0.17,
    carbsG: 13.81,
    fibreG: 2.4,
  },
  mango: {
    name: 'Mango',
    ndb: '09176',
    usda: 'MANGOS,RAW',
    water: 83.46,
    kcal: 60,
    proteinG: 0.82,
    fatG: 0.38,
    carbsG: 14.98,
    fibreG: 1.6,
  },
  papaya: {
    name: 'Papaya',
    ndb: '09226',
    usda: 'PAPAYAS,RAW',
    water: 88.06,
    kcal: 43,
    proteinG: 0.47,
    fatG: 0.26,
    carbsG: 10.82,
    fibreG: 1.7,
  },
  orange: {
    name: 'Orange',
    ndb: '09200',
    usda: 'ORANGES,RAW,ALL COMM VAR',
    water: 86.75,
    kcal: 47,
    proteinG: 0.94,
    fatG: 0.12,
    carbsG: 11.75,
    fibreG: 2.4,
  },
  guava: {
    name: 'Guava',
    ndb: '09139',
    usda: 'GUAVAS,COMMON,RAW',
    water: 80.8,
    kcal: 68,
    proteinG: 2.55,
    fatG: 0.95,
    carbsG: 14.32,
    fibreG: 5.4,
  },
  watermelon: {
    name: 'Watermelon',
    ndb: '09326',
    usda: 'WATERMELON,RAW',
    water: 91.45,
    kcal: 30,
    proteinG: 0.61,
    fatG: 0.15,
    carbsG: 7.55,
    fibreG: 0.4,
  },
  grapes: {
    name: 'Grapes',
    ndb: '09132',
    usda: 'GRAPES,RED OR GRN (EURO TYPE,SUCH AS THOMPSON SEEDLESS),RAW',
    water: 80.54,
    kcal: 69,
    proteinG: 0.72,
    fatG: 0.16,
    carbsG: 18.1,
    fibreG: 0.9,
  },
  pomegranate: {
    name: 'Pomegranate',
    ndb: '09286',
    usda: 'POMEGRANATES,RAW',
    water: 77.93,
    kcal: 83,
    proteinG: 1.67,
    fatG: 1.17,
    carbsG: 18.7,
    fibreG: 4,
  },
  'poppy-seeds': {
    name: 'Poppy seeds (posto, khus khus)',
    ndb: '02033',
    usda: 'POPPY SEED',
    water: 5.95,
    kcal: 525,
    proteinG: 17.99,
    fatG: 41.56,
    carbsG: 28.13,
    fibreG: 19.5,
  },
  'soy-sauce': {
    name: 'Soy sauce',
    ndb: '16123',
    usda: 'SOY SAU MADE FROM SOY&WHEAT (SHOYU)',
    water: 71.15,
    kcal: 53,
    proteinG: 8.14,
    fatG: 0.57,
    carbsG: 4.93,
    fibreG: 0.8,
  },
  cornflour: {
    name: 'Cornflour',
    ndb: '20027',
    usda: 'CORNSTARCH',
    water: 8.32,
    kcal: 381,
    proteinG: 0.26,
    fatG: 0.05,
    carbsG: 91.27,
    fibreG: 0.9,
  },
  'milk-powder': {
    name: 'Milk powder (for khoa)',
    ndb: '01090',
    usda: 'MILK,DRY,WHL,W/ ADDED VITAMIN D',
    water: 2.47,
    kcal: 496,
    proteinG: 26.32,
    fatG: 26.71,
    carbsG: 38.42,
    fibreG: 0,
  },
  'condensed-milk': {
    name: 'Condensed milk',
    ndb: '01095',
    usda: 'MILK,CND,COND,SWTND',
    water: 27.16,
    kcal: 321,
    proteinG: 7.91,
    fatG: 8.7,
    carbsG: 54.4,
    fibreG: 0,
  },
  'puffed-rice': {
    name: 'Puffed rice (murmura)',
    ndb: '08066',
    usda: 'CEREALS RTE,QUAKER,QUAKER PUFFED RICE',
    water: 3.91,
    kcal: 383,
    proteinG: 7.01,
    fatG: 0.9,
    carbsG: 87.78,
    fibreG: 1.4,
  },
  'peanut-butter': {
    name: 'Peanut butter',
    ndb: '16098',
    usda: 'PEANUT BUTTER,SMOOTH STYLE,W/ SALT',
    water: 1.23,
    kcal: 598,
    proteinG: 22.21,
    fatG: 51.36,
    carbsG: 22.31,
    fibreG: 5,
  },
  honey: {
    name: 'Honey',
    ndb: '19296',
    usda: 'HONEY',
    water: 17.1,
    kcal: 304,
    proteinG: 0.3,
    fatG: 0,
    carbsG: 82.4,
    fibreG: 0.2,
  },
  'coconut-water': {
    name: 'Coconut water',
    ndb: '12119',
    usda: 'COCONUT H2O (LIQ FROM COCONUTS)',
    water: 94.99,
    kcal: 19,
    proteinG: 0.72,
    fatG: 0.2,
    carbsG: 3.71,
    fibreG: 1.1,
  },
  cornflakes: {
    name: 'Cornflakes',
    ndb: '08020',
    usda: "CEREALS RTE,KELLOGG,KELLOGG'S CORN FLAKES",
    water: 3.76,
    kcal: 357,
    proteinG: 7.5,
    fatG: 0.4,
    carbsG: 84.1,
    fibreG: 3.3,
  },
  mayonnaise: {
    name: 'Mayonnaise',
    ndb: '04025',
    usda: 'SALAD DRSNG,MAYO,REG',
    water: 21.65,
    kcal: 680,
    proteinG: 0.96,
    fatG: 74.85,
    carbsG: 0.57,
    fibreG: 0,
  },
  ketchup: {
    name: 'Tomato ketchup',
    ndb: '11935',
    usda: 'Catsup',
    water: 68.51,
    kcal: 101,
    proteinG: 1.04,
    fatG: 0.1,
    carbsG: 27.4,
    fibreG: 0.3,
  },
  'spring-onion': {
    name: 'Spring onion',
    ndb: '11291',
    usda: 'ONIONS,SPRING OR SCALLIONS (INCL TOPS&BULB),RAW',
    water: 89.83,
    kcal: 32,
    proteinG: 1.83,
    fatG: 0.19,
    carbsG: 7.34,
    fibreG: 2.6,
  },
  vinegar: {
    name: 'Vinegar',
    ndb: '02048',
    usda: 'VINEGAR,CIDER',
    water: 93.81,
    kcal: 21,
    proteinG: 0,
    fatG: 0,
    carbsG: 0.93,
    fibreG: 0,
  },
  'coconut-milk': {
    name: 'Coconut milk',
    ndb: '12117',
    usda: 'COCONUT MILK,RAW (LIQ EXPRESSED FROM GRATED MEAT&H2O)',
    water: 67.62,
    kcal: 230,
    proteinG: 2.29,
    fatG: 23.84,
    carbsG: 5.54,
    fibreG: 2.2,
  },
  'mustard-seeds': {
    name: 'Mustard seeds',
    ndb: '02024',
    usda: 'SPICES,MUSTARD SD,GROUND',
    water: 5.27,
    kcal: 508,
    proteinG: 26.08,
    fatG: 36.24,
    carbsG: 28.09,
    fibreG: 12.2,
  },
  sesame: {
    name: 'Sesame seeds (til)',
    ndb: '12023',
    usda: 'SESAME SEEDS,WHOLE,DRIED',
    water: 4.69,
    kcal: 573,
    proteinG: 17.73,
    fatG: 49.67,
    carbsG: 23.45,
    fibreG: 11.8,
  },
  parmesan: {
    name: 'Parmesan cheese',
    ndb: '01032',
    usda: 'CHEESE,PARMESAN,GRATED',
    water: 22.65,
    kcal: 420,
    proteinG: 28.42,
    fatG: 27.84,
    carbsG: 13.91,
    fibreG: 0,
  },
  whey: {
    name: 'Whey protein powder',
    ndb: '14066',
    usda: 'BEVERAGES,PROT PDR WHEY BSD',
    water: 3.44,
    kcal: 352,
    proteinG: 78.13,
    fatG: 1.56,
    carbsG: 6.25,
    fibreG: 3.1,
  },
  'black-pepper': {
    name: 'Black pepper',
    ndb: '02030',
    usda: 'PEPPER,BLACK',
    water: 12.46,
    kcal: 251,
    proteinG: 10.39,
    fatG: 3.26,
    carbsG: 63.95,
    fibreG: 25.3,
  },
  tofu: {
    name: 'Tofu',
    ndb: '16426',
    usda: 'TOFU,RAW,FIRM,PREP W/CA SULFATE',
    water: 69.83,
    kcal: 144,
    proteinG: 17.27,
    fatG: 8.72,
    carbsG: 2.78,
    fibreG: 2.3,
  },
  'egg-white': {
    name: 'Egg white',
    ndb: '01124',
    usda: 'EGG,WHITE,RAW,FRESH',
    water: 87.57,
    kcal: 52,
    proteinG: 10.9,
    fatG: 0.17,
    carbsG: 0.73,
    fibreG: 0,
  },
  'chicken-breast-cooked': {
    name: 'Chicken breast, roasted',
    ndb: '05064',
    usda: 'CHICKEN,BROILERS OR FRYERS,BREAST,MEAT ONLY,CKD,RSTD',
    water: 65.26,
    kcal: 165,
    proteinG: 31.02,
    fatG: 3.57,
    carbsG: 0,
    fibreG: 0,
  },
  'brown-rice-cooked': {
    name: 'Brown rice, cooked',
    ndb: '20037',
    usda: 'RICE,BROWN,LONG-GRAIN,CKD',
    water: 70.27,
    kcal: 123,
    proteinG: 2.74,
    fatG: 0.97,
    carbsG: 25.58,
    fibreG: 1.6,
  },
  'quinoa-cooked': {
    name: 'Quinoa, cooked',
    ndb: '20137',
    usda: 'QUINOA,CKD',
    water: 71.61,
    kcal: 120,
    proteinG: 4.4,
    fatG: 1.92,
    carbsG: 21.3,
    fibreG: 2.8,
  },
  'sweet-potato-baked': {
    name: 'Sweet potato, baked',
    ndb: '11508',
    usda: 'SWEET POTATO,CKD,BKD IN SKN,FLESH,WO/ SALT',
    water: 75.78,
    kcal: 90,
    proteinG: 2.01,
    fatG: 0.15,
    carbsG: 20.71,
    fibreG: 3.3,
  },
  dates: {
    name: 'Dates (khajur)',
    ndb: '09087',
    usda: 'DATES,DEGLET NOOR',
    water: 20.53,
    kcal: 282,
    proteinG: 2.45,
    fatG: 0.39,
    carbsG: 75.03,
    fibreG: 8,
  },
  'tuna-canned': {
    name: 'Tuna, canned in water',
    ndb: '15121',
    usda: 'FISH,TUNA,LT,CND IN H2O,DRND SOL',
    water: 78.14,
    kcal: 86,
    proteinG: 19.44,
    fatG: 0.96,
    carbsG: 0,
    fibreG: 0,
  },
  'milk-skimmed': {
    name: 'Milk, skimmed',
    ndb: '01085',
    usda: 'MILK,NONFAT,FLUID,W/ ADDED VIT A & VIT D (FAT FREE OR SKIM)',
    water: 90.84,
    kcal: 34,
    proteinG: 3.37,
    fatG: 0.08,
    carbsG: 4.96,
    fibreG: 0,
  },
  'greek-yogurt': {
    name: 'Greek yogurt / hung curd, low fat',
    ndb: '01256',
    usda: 'YOGURT,GREEK,PLN,NONFAT',
    water: 85.1,
    kcal: 59,
    proteinG: 10.19,
    fatG: 0.39,
    carbsG: 3.6,
    fibreG: 0,
  },
  'brown-bread': {
    name: 'Brown bread (whole wheat)',
    ndb: '18075',
    usda: 'BREAD,WHOLE-WHEAT,COMM. PREPARED',
    water: 39.01,
    kcal: 252,
    proteinG: 12.45,
    fatG: 3.5,
    carbsG: 42.71,
    fibreG: 6,
  },
  'chickpeas-boiled': {
    name: 'Chickpeas, boiled',
    ndb: '16057',
    usda: 'CHICKPEAS ,MATURE SEEDS,CKD,BLD,WO/SALT',
    water: 60.21,
    kcal: 164,
    proteinG: 8.86,
    fatG: 2.59,
    carbsG: 27.42,
    fibreG: 7.6,
  },
  'rajma-boiled': {
    name: 'Kidney beans, boiled',
    ndb: '16033',
    usda: 'BEANS,KIDNEY,RED,MATURE SEEDS,CKD,BLD,WO/SALT',
    water: 66.94,
    kcal: 127,
    proteinG: 8.67,
    fatG: 0.5,
    carbsG: 22.8,
    fibreG: 7.4,
  },
  'oats-cooked': {
    name: 'Oats, cooked in water',
    ndb: '08121',
    usda: 'CEREALS,OATS,REG & QUICK,UNENR,CKD W/ H2O,WO/ SALT',
    water: 83.61,
    kcal: 71,
    proteinG: 2.54,
    fatG: 1.52,
    carbsG: 12,
    fibreG: 1.7,
  },
  'lotus-seeds': {
    name: 'Lotus seeds (makhana), dried',
    ndb: '12013',
    usda: 'LOTUS SEEDS,DRIED',
    water: 14.16,
    kcal: 332,
    proteinG: 15.41,
    fatG: 1.97,
    carbsG: 64.47,
    fibreG: 0,
  },
  ladyfingers: {
    name: 'Ladyfinger biscuits',
    ndb: '18423',
    usda: 'COOKIES,LADYFINGERS,WO/LEMON JUC&RIND',
    water: 19.5,
    kcal: 363,
    proteinG: 10.6,
    fatG: 9.1,
    carbsG: 59.7,
    fibreG: 1,
  },
  'cream-cheese': {
    name: 'Cream cheese',
    ndb: '01017',
    usda: 'CHEESE,CREAM',
    water: 52.62,
    kcal: 350,
    proteinG: 6.15,
    fatG: 34.44,
    carbsG: 5.52,
    fibreG: 0,
  },
  'evaporated-milk': {
    name: 'Evaporated milk',
    ndb: '01096',
    usda: 'MILK,CND,EVAP,W/ ADDED VITAMIN D & WO/ ADDED VIT A',
    water: 74.04,
    kcal: 134,
    proteinG: 6.81,
    fatG: 7.56,
    carbsG: 10.04,
    fibreG: 0,
  },
  avocado: {
    name: 'Avocado',
    ndb: '09037',
    usda: 'AVOCADOS,RAW,ALL COMM VAR',
    water: 73.23,
    kcal: 160,
    proteinG: 2,
    fatG: 14.66,
    carbsG: 8.53,
    fibreG: 6.7,
  },
  croissant: {
    name: 'Croissant (butter)',
    ndb: '18239',
    usda: 'CROISSANTS,BUTTER',
    water: 23.2,
    kcal: 406,
    proteinG: 8.2,
    fatG: 21,
    carbsG: 45.8,
    fibreG: 2.6,
  },
  espresso: {
    name: 'Espresso',
    ndb: '14210',
    usda: 'BEVERAGES,COFFEE,BREWED,ESPRESSO,REST-PREP',
    water: 97.8,
    kcal: 9,
    proteinG: 0.12,
    fatG: 0.18,
    carbsG: 1.67,
    fibreG: 0,
  },
  waffle: {
    name: 'Waffle, plain',
    ndb: '18367',
    usda: 'WAFFLES,PLN,PREP FROM RECIPE',
    water: 42,
    kcal: 291,
    proteinG: 7.9,
    fatG: 14.1,
    carbsG: 32.9,
    fibreG: 0,
  },
  pancake: {
    name: 'Pancake, plain',
    ndb: '18293',
    usda: 'PANCAKES,PLN,PREP FROM RECIPE',
    water: 52.9,
    kcal: 227,
    proteinG: 6.4,
    fatG: 9.7,
    carbsG: 28.3,
    fibreG: 0,
  },
  salmon: {
    name: 'Salmon',
    ndb: '15236',
    usda: 'SALMON,ATLANTIC,FARMED,RAW',
    water: 64.89,
    kcal: 208,
    proteinG: 20.42,
    fatG: 13.42,
    carbsG: 0,
    fibreG: 0,
  },
  nori: {
    name: 'Seaweed (nori)',
    ndb: '11446',
    usda: 'SEAWEED,LAVER,RAW',
    water: 85.03,
    kcal: 35,
    proteinG: 5.81,
    fatG: 0.28,
    carbsG: 5.11,
    fibreG: 0.3,
  },
  mozzarella: {
    name: 'Mozzarella',
    ndb: '01026',
    usda: 'CHEESE,MOZZARELLA,WHL MILK',
    water: 50.01,
    kcal: 300,
    proteinG: 22.17,
    fatG: 22.35,
    carbsG: 2.19,
    fibreG: 0,
  },
  'puff-pastry': {
    name: 'Puff pastry, baked',
    ndb: '18211',
    usda: 'PUFF PASTRY,FRZ,RTB,BKD',
    water: 7.4,
    kcal: 558,
    proteinG: 7.4,
    fatG: 38.5,
    carbsG: 45.7,
    fibreG: 1.5,
  },
  phyllo: {
    name: 'Phyllo dough',
    ndb: '18338',
    usda: 'PHYLLO DOUGH',
    water: 32.6,
    kcal: 299,
    proteinG: 7.1,
    fatG: 6,
    carbsG: 52.6,
    fibreG: 1.9,
  },
  'maple-syrup': {
    name: 'Maple syrup',
    ndb: '19353',
    usda: 'SYRUPS,MAPLE',
    water: 32.39,
    kcal: 260,
    proteinG: 0.04,
    fatG: 0.06,
    carbsG: 67.04,
    fibreG: 0,
  },
  'tapioca-pearls': {
    name: 'Tapioca pearls, dry',
    ndb: '20068',
    usda: 'TAPIOCA,PEARL,DRY',
    water: 10.99,
    kcal: 358,
    proteinG: 0.19,
    fatG: 0.02,
    carbsG: 88.69,
    fibreG: 0.9,
  },
  pita: {
    name: 'Pita bread',
    ndb: '18041',
    usda: 'BREAD,PITA,WHITE,ENRICHED',
    water: 32.1,
    kcal: 275,
    proteinG: 9.1,
    fatG: 1.2,
    carbsG: 55.7,
    fibreG: 2.2,
  },
  hummus: {
    name: 'Hummus',
    ndb: '16158',
    usda: 'HUMMUS,COMMERCIAL',
    water: 66.59,
    kcal: 166,
    proteinG: 7.9,
    fatG: 9.6,
    carbsG: 14.29,
    fibreG: 6,
  },
  falafel: {
    name: 'Falafel',
    ndb: '16138',
    usda: 'FALAFEL,HOME-PREPARED',
    water: 34.62,
    kcal: 333,
    proteinG: 13.31,
    fatG: 17.8,
    carbsG: 31.84,
    fibreG: 0,
  },
  feta: {
    name: 'Feta',
    ndb: '01019',
    usda: 'CHEESE,FETA',
    water: 55.22,
    kcal: 264,
    proteinG: 14.21,
    fatG: 21.28,
    carbsG: 4.09,
    fibreG: 0,
  },
  olives: {
    name: 'Olives',
    ndb: '09193',
    usda: 'OLIVES,RIPE,CND (SMALL-EXTRA LRG)',
    water: 79.99,
    kcal: 115,
    proteinG: 0.84,
    fatG: 10.68,
    carbsG: 6.26,
    fibreG: 3.2,
  },
  lettuce: {
    name: 'Lettuce (romaine)',
    ndb: '11251',
    usda: 'LETTUCE,COS OR ROMAINE,RAW',
    water: 94.61,
    kcal: 17,
    proteinG: 1.23,
    fatG: 0.3,
    carbsG: 3.29,
    fibreG: 2.1,
  },
  chia: {
    name: 'Chia seeds',
    ndb: '12006',
    usda: 'CHIA SEEDS,DRIED',
    water: 5.8,
    kcal: 486,
    proteinG: 16.54,
    fatG: 30.74,
    carbsG: 42.12,
    fibreG: 34.4,
  },
  bagel: {
    name: 'Bagel',
    ndb: '18406',
    usda: 'BAGELS,PLN,ENR,WO/CA PROP (INCL ONION,POPPY,SESAME)',
    water: 32.6,
    kcal: 275,
    proteinG: 10.5,
    fatG: 1.6,
    carbsG: 53.4,
    fibreG: 2.3,
  },
  'dark-chocolate': {
    name: 'Dark chocolate (60 to 69%)',
    ndb: '19903',
    usda: 'CHOCOLATE,DK,60-69% CACAO SOL',
    water: 1.25,
    kcal: 579,
    proteinG: 6.12,
    fatG: 38.31,
    carbsG: 52.42,
    fibreG: 8,
  },
  'milk-chocolate': {
    name: 'Milk chocolate',
    ndb: '19120',
    usda: 'CANDIES,MILK CHOC',
    water: 1.5,
    kcal: 535,
    proteinG: 7.65,
    fatG: 29.66,
    carbsG: 59.4,
    fibreG: 3.4,
  },
  'sponge-cake': {
    name: 'Sponge cake',
    ndb: '18133',
    usda: 'CAKE,SPONGE,COMMLY PREP',
    water: 29.7,
    kcal: 290,
    proteinG: 5.4,
    fatG: 2.7,
    carbsG: 61,
    fibreG: 0.5,
  },
  strawberries: {
    name: 'Strawberries',
    ndb: '09316',
    usda: 'STRAWBERRIES,RAW',
    water: 90.95,
    kcal: 32,
    proteinG: 0.67,
    fatG: 0.3,
    carbsG: 7.68,
    fibreG: 2,
  },
  blueberries: {
    name: 'Blueberries',
    ndb: '09050',
    usda: 'BLUEBERRIES,RAW',
    water: 84.21,
    kcal: 57,
    proteinG: 0.74,
    fatG: 0.33,
    carbsG: 14.49,
    fibreG: 2.4,
  },
  brownie: {
    name: 'Brownie',
    ndb: '18151',
    usda: 'COOKIES,BROWNIES,COMMLY PREP',
    water: 13.6,
    kcal: 405,
    proteinG: 4.8,
    fatG: 16.3,
    carbsG: 63.9,
    fibreG: 2.1,
  },
  'choc-chip-cookie': {
    name: 'Chocolate chip cookie',
    ndb: '18159',
    usda: 'COOKIES,CHOC CHIP,COMMLY PREP,REG,HIGHER FAT,ENR',
    water: 3.57,
    kcal: 492,
    proteinG: 5.1,
    fatG: 24.72,
    carbsG: 65.36,
    fibreG: 2,
  },
  'glazed-doughnut': {
    name: 'Glazed doughnut',
    ndb: '18436',
    usda: 'DOUGHNUTS,YEAST-LEAVENED,GLAZED,UNENR (INCL HONEY BUNS)',
    water: 25.4,
    kcal: 403,
    proteinG: 6.4,
    fatG: 22.8,
    carbsG: 44.3,
    fibreG: 1.2,
  },
  cheesecake: {
    name: 'Cheesecake',
    ndb: '18147',
    usda: 'CHEESECAKE COMMLY PREP',
    water: 45.6,
    kcal: 321,
    proteinG: 5.5,
    fatG: 22.5,
    carbsG: 25.5,
    fibreG: 0.4,
  },
  'sushi-rice': {
    name: 'Short-grain rice, cooked',
    ndb: '20453',
    usda: 'RICE,WHITE,SHORT-GRAIN,CKD,UNENR',
    water: 68.53,
    kcal: 130,
    proteinG: 2.36,
    fatG: 0.19,
    carbsG: 28.73,
    fibreG: 0,
  },
  'ice-cream': {
    name: 'Vanilla ice cream',
    ndb: '19095',
    usda: 'ICE CREAMS,VANILLA',
    water: 61,
    kcal: 207,
    proteinG: 3.5,
    fatG: 11,
    carbsG: 23.6,
    fibreG: 0.7,
  },
  'choc-ice-cream': {
    name: 'Chocolate ice cream',
    ndb: '19270',
    usda: 'ICE CREAMS,CHOC',
    water: 55.7,
    kcal: 216,
    proteinG: 3.8,
    fatG: 11,
    carbsG: 28.2,
    fibreG: 1.2,
  },
  'olive-oil': {
    name: 'Olive oil',
    ndb: '04053',
    usda: 'OIL,OLIVE,SALAD OR COOKING',
    water: 0,
    kcal: 884,
    proteinG: 0,
    fatG: 100,
    carbsG: 0,
    fibreG: 0,
  },
  granola: {
    name: 'Granola',
    ndb: '08037',
    usda: 'CEREALS RTE,GRANOLA,HOMEMADE',
    water: 5.84,
    kcal: 489,
    proteinG: 13.67,
    fatG: 24.31,
    carbsG: 53.88,
    fibreG: 8.9,
  },
  'whipped-cream': {
    name: 'Whipped cream',
    ndb: '01054',
    usda: 'CREAM,WHIPPED,CRM TOPPING,PRESSURIZED',
    water: 61.33,
    kcal: 257,
    proteinG: 3.2,
    fatG: 22.22,
    carbsG: 12.49,
    fibreG: 0,
  },
  'flour-tortilla': {
    name: 'Flour tortilla',
    ndb: '18364',
    usda: 'TORTILLAS,RTB OR -FRY,FLR,REFR',
    water: 31.98,
    kcal: 306,
    proteinG: 8.2,
    fatG: 7.99,
    carbsG: 49.38,
    fibreG: 3.5,
  },
  'pasta-cooked': {
    name: 'Pasta, cooked',
    ndb: '20121',
    usda: 'PASTA,CKD,ENR,WO/ ADDED SALT',
    water: 62.13,
    kcal: 158,
    proteinG: 5.8,
    fatG: 0.93,
    carbsG: 30.86,
    fibreG: 1.8,
  },
  'sweet-corn': {
    name: 'Sweet corn',
    ndb: '11170',
    usda: 'CORN,SWT,YEL,CND,BRINE PK,REG PK,SOL&LIQUIDS',
    water: 82.61,
    kcal: 61,
    proteinG: 1.95,
    fatG: 0.77,
    carbsG: 13.86,
    fibreG: 1.7,
  },
  'brown-sugar': {
    name: 'Brown sugar',
    ndb: '19334',
    usda: 'SUGARS,BROWN',
    water: 1.34,
    kcal: 380,
    proteinG: 0.12,
    fatG: 0,
    carbsG: 98.09,
    fibreG: 0,
  },
  sourdough: {
    name: 'Sourdough (English muffin)',
    ndb: '18258',
    usda: 'ENGLISH MUFFIN, PLN,ENCHED.W/CA PROP (INCLD SOURDOUGH)',
    water: 43.56,
    kcal: 227,
    proteinG: 8.87,
    fatG: 1.69,
    carbsG: 44.17,
    fibreG: 3.5,
  },
  'multigrain-bread': {
    name: 'Multigrain bread',
    ndb: '18036',
    usda: 'BREAD,MULTI-GRAIN,TSTD (INCLUDES WHOLE-GRAIN)',
    water: 31.46,
    kcal: 288,
    proteinG: 14.52,
    fatG: 4.6,
    carbsG: 47.11,
    fibreG: 8.1,
  },
  pineapple: {
    name: 'Pineapple',
    ndb: '09266',
    usda: 'PINEAPPLE,RAW,ALL VAR',
    water: 86,
    kcal: 50,
    proteinG: 0.54,
    fatG: 0.12,
    carbsG: 13.12,
    fibreG: 1.4,
  },
  kiwi: {
    name: 'Kiwi',
    ndb: '09148',
    usda: 'KIWIFRUIT,GRN,RAW',
    water: 83.07,
    kcal: 61,
    proteinG: 1.14,
    fatG: 0.52,
    carbsG: 14.66,
    fibreG: 3,
  },
  lychee: {
    name: 'Lychee',
    ndb: '09164',
    usda: 'LITCHIS,RAW',
    water: 81.76,
    kcal: 66,
    proteinG: 0.83,
    fatG: 0.44,
    carbsG: 16.53,
    fibreG: 1.3,
  },
  jackfruit: {
    name: 'Jackfruit',
    ndb: '09144',
    usda: 'JACKFRUIT,RAW',
    water: 73.46,
    kcal: 95,
    proteinG: 1.72,
    fatG: 0.64,
    carbsG: 23.25,
    fibreG: 1.5,
  },
  sapota: {
    name: 'Sapota (chikoo)',
    ndb: '09313',
    usda: 'SAPODILLA,RAW',
    water: 78,
    kcal: 83,
    proteinG: 0.44,
    fatG: 1.1,
    carbsG: 19.96,
    fibreG: 5.3,
    note: 'Sapodilla values.',
  },
  'custard-apple': {
    name: 'Custard apple (sitaphal)',
    ndb: '09321',
    usda: 'SUGAR-APPLES,(SWEETSOP),RAW',
    water: 73.23,
    kcal: 94,
    proteinG: 2.06,
    fatG: 0.29,
    carbsG: 23.64,
    fibreG: 4.4,
    note: 'Sugar-apple (sweetsop) values.',
  },
  soymilk: {
    name: 'Soy milk',
    ndb: '16120',
    usda: 'SOYMILK,ORIGINAL & VANILLA,UNFORTIFIED',
    water: 88.05,
    kcal: 54,
    proteinG: 3.27,
    fatG: 1.75,
    carbsG: 6.28,
    fibreG: 0.6,
  },
  pistachios: {
    name: 'Pistachios',
    ndb: '12151',
    usda: 'PISTACHIO NUTS,RAW',
    water: 4.37,
    kcal: 560,
    proteinG: 20.16,
    fatG: 45.32,
    carbsG: 27.17,
    fibreG: 10.6,
  },
  walnuts: {
    name: 'Walnuts',
    ndb: '12155',
    usda: 'WALNUTS,ENGLISH',
    water: 4.07,
    kcal: 654,
    proteinG: 15.23,
    fatG: 65.21,
    carbsG: 13.71,
    fibreG: 6.7,
  },
  flaxseed: {
    name: 'Flax seeds (alsi)',
    ndb: '12220',
    usda: 'SEEDS,FLAXSEED',
    water: 6.96,
    kcal: 534,
    proteinG: 18.29,
    fatG: 42.16,
    carbsG: 28.88,
    fibreG: 27.3,
  },
  'pumpkin-seeds': {
    name: 'Pumpkin seeds',
    ndb: '12014',
    usda: 'PUMPKIN&SQUASH SD KRNLS,DRIED',
    water: 5.23,
    kcal: 559,
    proteinG: 30.23,
    fatG: 49.05,
    carbsG: 10.71,
    fibreG: 6,
  },
  'sunflower-seeds': {
    name: 'Sunflower seeds',
    ndb: '12036',
    usda: 'SUNFLOWER SD KRNLS,DRIED',
    water: 4.73,
    kcal: 584,
    proteinG: 20.78,
    fatG: 51.46,
    carbsG: 20,
    fibreG: 8.6,
  },
  popcorn: {
    name: 'Popcorn, air-popped',
    ndb: '19034',
    usda: 'POPCORN,AIR-POPPED',
    water: 3.32,
    kcal: 387,
    proteinG: 12.94,
    fatG: 4.54,
    carbsG: 77.78,
    fibreG: 14.5,
  },
  'pork-belly': {
    name: 'Pork belly',
    ndb: '10005',
    usda: 'PORK,FRSH,BELLY,RAW',
    water: 36.74,
    kcal: 518,
    proteinG: 9.34,
    fatG: 53.01,
    carbsG: 0,
    fibreG: 0,
  },
  bacon: {
    name: 'Bacon',
    ndb: '10123',
    usda: 'PORK,CURED,BACON,UNPREP',
    water: 44.24,
    kcal: 417,
    proteinG: 12.62,
    fatG: 39.69,
    carbsG: 1.28,
    fibreG: 0,
  },
  'beef-mince': {
    name: 'Beef mince',
    ndb: '23572',
    usda: 'BEEF,GROUND,80% LN MEAT / 20% FAT,RAW',
    water: 61.87,
    kcal: 254,
    proteinG: 17.17,
    fatG: 20,
    carbsG: 0,
    fibreG: 0,
    note: '80% lean ground beef values.',
  },
  'mutton-mince': {
    name: 'Mutton mince (keema)',
    ndb: '17224',
    usda: 'LAMB,GROUND,RAW',
    water: 59.47,
    kcal: 282,
    proteinG: 16.56,
    fatG: 23.41,
    carbsG: 0,
    fibreG: 0,
    note: 'Ground lamb values.',
  },
  'chicken-drumstick': {
    name: 'Chicken drumstick, with skin',
    ndb: '05066',
    usda: 'CHICKEN,BROILERS OR FRYERS,DRUMSTK,MEAT&SKN,RAW',
    water: 72.46,
    kcal: 161,
    proteinG: 18.08,
    fatG: 9.2,
    carbsG: 0.11,
    fibreG: 0,
  },
  'chicken-thigh': {
    name: 'Chicken thigh, with skin',
    ndb: '05091',
    usda: 'CHICKEN,BROILERS OR FRYERS,THIGH,MEAT&SKN,RAW',
    water: 66.47,
    kcal: 221,
    proteinG: 16.52,
    fatG: 16.61,
    carbsG: 0.25,
    fibreG: 0,
  },
  'chicken-wing': {
    name: 'Chicken wing, with skin',
    ndb: '05100',
    usda: 'CHICKEN,BROILERS OR FRYERS,WING,MEAT&SKN,RAW',
    water: 69.19,
    kcal: 191,
    proteinG: 17.52,
    fatG: 12.85,
    carbsG: 0,
    fibreG: 0,
  },
  mussels: {
    name: 'Mussels (kallummakkaya)',
    ndb: '15164',
    usda: 'MUSSEL,BLUE,RAW',
    water: 80.58,
    kcal: 86,
    proteinG: 11.9,
    fatG: 2.24,
    carbsG: 3.69,
    fibreG: 0,
  },
  'ash-gourd': {
    name: 'Ash gourd (petha)',
    ndb: '11593',
    usda: 'WAXGOURD,(CHINESE PRESERVING MELON),RAW',
    water: 96.1,
    kcal: 13,
    proteinG: 0.4,
    fatG: 0.2,
    carbsG: 3,
    fibreG: 2.9,
    note: 'Wax gourd values.',
  },
  'ridge-gourd': {
    name: 'Ridge gourd (turai)',
    ndb: '11220',
    usda: 'GOURD,DISHCLOTH (TOWELGOURD),RAW',
    water: 93.85,
    kcal: 20,
    proteinG: 1.2,
    fatG: 0.2,
    carbsG: 4.35,
    fibreG: 1.1,
    note: 'Towel gourd values.',
  },
  turnip: {
    name: 'Turnip (shalgam)',
    ndb: '11564',
    usda: 'TURNIPS,RAW',
    water: 91.87,
    kcal: 28,
    proteinG: 0.9,
    fatG: 0.1,
    carbsG: 6.43,
    fibreG: 1.8,
  },
  'lotus-stem': {
    name: 'Lotus stem (kamal kakdi)',
    ndb: '11254',
    usda: 'LOTUS ROOT,RAW',
    water: 79.1,
    kcal: 74,
    proteinG: 2.6,
    fatG: 0.1,
    carbsG: 17.23,
    fibreG: 4.9,
  },
  'amaranth-leaves': {
    name: 'Amaranth leaves (chaulai)',
    ndb: '11003',
    usda: 'AMARANTH LEAVES,RAW',
    water: 91.69,
    kcal: 23,
    proteinG: 2.46,
    fatG: 0.33,
    carbsG: 4.02,
    fibreG: 0,
  },
  dill: {
    name: 'Dill leaves (suva)',
    ndb: '02045',
    usda: 'DILL WEED,FRSH',
    water: 85.95,
    kcal: 43,
    proteinG: 3.46,
    fatG: 1.12,
    carbsG: 7.02,
    fibreG: 2.1,
  },
  'broad-beans': {
    name: 'Broad beans (sem)',
    ndb: '11088',
    usda: 'BROADBEANS,IMMAT SEEDS,RAW',
    water: 81,
    kcal: 72,
    proteinG: 5.6,
    fatG: 0.6,
    carbsG: 11.7,
    fibreG: 4.2,
  },
  'bamboo-shoot': {
    name: 'Bamboo shoot',
    ndb: '11026',
    usda: 'BAMBOO SHOOTS,RAW',
    water: 91,
    kcal: 27,
    proteinG: 2.6,
    fatG: 0.3,
    carbsG: 5.2,
    fibreG: 2.2,
  },
  'amaranth-grain': {
    name: 'Amaranth grain (rajgira)',
    ndb: '20001',
    usda: 'AMARANTH GRAIN,UNCKD',
    water: 11.29,
    kcal: 371,
    proteinG: 13.56,
    fatG: 7.02,
    carbsG: 65.25,
    fibreG: 6.7,
  },
  'milk-powder-whole': {
    name: 'Whole milk powder',
    ndb: '01090',
    usda: 'MILK,DRY,WHL,W/ ADDED VITAMIN D',
    water: 2.47,
    kcal: 496,
    proteinG: 26.32,
    fatG: 26.71,
    carbsG: 38.42,
    fibreG: 0,
  },
  'egg-noodles': {
    name: 'Noodles, dry',
    ndb: '20109',
    usda: 'NOODLES,EGG,DRY,ENRICHED',
    water: 9.01,
    kcal: 384,
    proteinG: 14.16,
    fatG: 4.44,
    carbsG: 71.27,
    fibreG: 3.3,
    note: 'Dry egg noodle values; Hakka noodles.',
  },
  'rice-noodles': {
    name: 'Rice noodles, dry',
    ndb: '20133',
    usda: 'RICE NOODLES,DRY',
    water: 11.91,
    kcal: 364,
    proteinG: 5.95,
    fatG: 0.56,
    carbsG: 80.18,
    fibreG: 1.6,
  },
  arrowroot: {
    name: 'Arrowroot flour',
    ndb: '20003',
    usda: 'ARROWROOT FLOUR',
    water: 11.37,
    kcal: 357,
    proteinG: 0.3,
    fatG: 0.1,
    carbsG: 88.15,
    fibreG: 3.4,
  },
  'figs-dried': {
    name: 'Dried figs (anjeer)',
    ndb: '09094',
    usda: 'FIGS,DRIED,UNCOOKED',
    water: 30.05,
    kcal: 249,
    proteinG: 3.3,
    fatG: 0.93,
    carbsG: 63.87,
    fibreG: 9.8,
  },
  'apricots-dried': {
    name: 'Dried apricots (khubani)',
    ndb: '09032',
    usda: 'APRICOTS,DRIED,SULFURED,UNCKD',
    water: 30.89,
    kcal: 241,
    proteinG: 3.39,
    fatG: 0.51,
    carbsG: 62.64,
    fibreG: 7.3,
  },
  lime: {
    name: 'Lime juice',
    ndb: '09160',
    usda: 'LIME JUICE,RAW',
    water: 90.79,
    kcal: 25,
    proteinG: 0.42,
    fatG: 0.07,
    carbsG: 8.42,
    fibreG: 0.4,
  },
  celery: {
    name: 'Celery',
    ndb: '11143',
    usda: 'CELERY,RAW',
    water: 95.43,
    kcal: 16,
    proteinG: 0.69,
    fatG: 0.17,
    carbsG: 2.97,
    fibreG: 1.6,
  },
  broccoli: {
    name: 'Broccoli',
    ndb: '11090',
    usda: 'BROCCOLI,RAW',
    water: 89.3,
    kcal: 34,
    proteinG: 2.82,
    fatG: 0.37,
    carbsG: 6.64,
    fibreG: 2.6,
  },
  zucchini: {
    name: 'Zucchini',
    ndb: '11477',
    usda: 'SQUASH,SMMR,ZUCCHINI,INCL SKN,RAW',
    water: 94.79,
    kcal: 17,
    proteinG: 1.21,
    fatG: 0.32,
    carbsG: 3.11,
    fibreG: 1,
  },
  leek: {
    name: 'Leek',
    ndb: '11246',
    usda: 'LEEKS,(BULB&LOWER LEAF-PORTION),RAW',
    water: 83,
    kcal: 61,
    proteinG: 1.5,
    fatG: 0.3,
    carbsG: 14.15,
    fibreG: 1.8,
  },
  shallots: {
    name: 'Shallots (sambar onion)',
    ndb: '11677',
    usda: 'SHALLOTS,RAW',
    water: 79.8,
    kcal: 72,
    proteinG: 2.5,
    fatG: 0.1,
    carbsG: 16.8,
    fibreG: 3.2,
  },
  'plantain-ripe': {
    name: 'Plantain, ripe (nendran)',
    ndb: '09277',
    usda: 'PLANTAINS,RAW',
    water: 65.28,
    kcal: 122,
    proteinG: 1.3,
    fatG: 0.37,
    carbsG: 31.89,
    fibreG: 2.3,
  },
  saffron: {
    name: 'Saffron (kesar)',
    ndb: '02037',
    usda: 'SAFFRON',
    water: 11.9,
    kcal: 310,
    proteinG: 11.43,
    fatG: 5.85,
    carbsG: 65.37,
    fibreG: 3.9,
  },
  'mustard-sauce': {
    name: 'Mustard, prepared',
    ndb: '02046',
    usda: 'MUSTARD,PREPARED,YELLOW',
    water: 83.72,
    kcal: 60,
    proteinG: 3.74,
    fatG: 3.34,
    carbsG: 5.83,
    fibreG: 4,
  },
  ragi: {
    name: 'Finger millet (ragi)',
    ndb: '',
    usda: '',
    ifct: 'A010 Ragi',
    water: 10.89,
    kcal: 343,
    proteinG: 7.16,
    fatG: 1.92,
    carbsG: 78,
    fibreG: 11.18,
  },
  'little-millet': {
    name: 'Little millet (samai, samak)',
    ndb: '',
    usda: '',
    ifct: 'A016 Samai',
    water: 11.36,
    kcal: 362,
    proteinG: 10.13,
    fatG: 3.89,
    carbsG: 73.27,
    fibreG: 7.72,
    note: 'Little millet values; barnyard millet (samak) is close.',
  },
  'kodo-millet': {
    name: 'Kodo millet (varagu)',
    ndb: '',
    usda: '',
    ifct: 'A017 Varagu',
    water: 14.23,
    kcal: 345,
    proteinG: 8.92,
    fatG: 2.55,
    carbsG: 72.58,
    fibreG: 6.39,
  },
  'rice-flakes': {
    name: 'Rice flakes (poha), IFCT',
    ndb: '',
    usda: '',
    ifct: 'A011 Rice flakes',
    water: 10.36,
    kcal: 361,
    proteinG: 7.44,
    fatG: 1.14,
    carbsG: 80.21,
    fibreG: 3.46,
  },
  dalia: {
    name: 'Broken wheat (dalia)',
    ndb: '',
    usda: '',
    ifct: 'A021 Wheat, bulgur',
    water: 8.61,
    kcal: 359,
    proteinG: 10.84,
    fatG: 1.45,
    carbsG: 77.87,
    fibreG: 8.81,
    note: 'Bulgur values.',
  },
  soybean: {
    name: 'Soybeans',
    ndb: '',
    usda: '',
    ifct: 'B025 Soya bean, white',
    water: 5.47,
    kcal: 423,
    proteinG: 37.8,
    fatG: 19.42,
    carbsG: 32.79,
    fibreG: 22.63,
  },
  'horse-gram': {
    name: 'Horse gram (kulthi)',
    ndb: '',
    usda: '',
    ifct: 'B012 Horse gram, whole',
    water: 9.28,
    kcal: 345,
    proteinG: 21.73,
    fatG: 0.62,
    carbsG: 65.12,
    fibreG: 7.88,
  },
  'moth-bean': {
    name: 'Moth beans (matki)',
    ndb: '',
    usda: '',
    ifct: 'B016 Moth bean',
    water: 8.14,
    kcal: 339,
    proteinG: 19.75,
    fatG: 1.76,
    carbsG: 67.21,
    fibreG: 15.12,
  },
  lobia: {
    name: 'Cowpea (lobia)',
    ndb: '',
    usda: '',
    ifct: 'B005 Cowpea, brown',
    water: 9.42,
    kcal: 343,
    proteinG: 20.36,
    fatG: 1.15,
    carbsG: 66.16,
    fibreG: 11.54,
  },
  val: {
    name: 'Field beans (val, avarekalu)',
    ndb: '',
    usda: '',
    ifct: 'B008 Field bean, brown',
    water: 8.74,
    kcal: 328,
    proteinG: 19.9,
    fatG: 0.98,
    carbsG: 67.64,
    fibreG: 22.4,
  },
  'dry-peas': {
    name: 'Dried peas (vatana)',
    ndb: '',
    usda: '',
    ifct: 'B017 Peas, dry',
    water: 9.33,
    kcal: 337,
    proteinG: 20.43,
    fatG: 1.89,
    carbsG: 65.94,
    fibreG: 17.01,
  },
  'moong-whole': {
    name: 'Whole moong',
    ndb: '',
    usda: '',
    ifct: 'B011 Green gram, whole',
    water: 9.95,
    kcal: 328,
    proteinG: 22.53,
    fatG: 1.14,
    carbsG: 63.17,
    fibreG: 17.04,
  },
  'urad-whole': {
    name: 'Whole urad',
    ndb: '',
    usda: '',
    ifct: 'B004 Black gram, whole',
    water: 8.7,
    kcal: 332,
    proteinG: 21.97,
    fatG: 1.58,
    carbsG: 64.4,
    fibreG: 20.41,
  },
  'kala-chana': {
    name: 'Black chickpeas (kala chana)',
    ndb: '',
    usda: '',
    ifct: 'B002 Bengal gram, whole',
    water: 8.56,
    kcal: 337,
    proteinG: 18.77,
    fatG: 5.11,
    carbsG: 64.78,
    fibreG: 25.22,
  },
  'masoor-whole': {
    name: 'Whole masoor',
    ndb: '',
    usda: '',
    ifct: 'B014 Lentil whole, brown',
    water: 9.2,
    kcal: 333,
    proteinG: 22.49,
    fatG: 0.64,
    carbsG: 65.29,
    fibreG: 16.82,
  },
  khoya: {
    name: 'Khoya (mawa)',
    ndb: '',
    usda: '',
    ifct: 'L004 Khoa',
    water: 42.51,
    kcal: 316,
    proteinG: 16.34,
    fatG: 20.62,
    carbsG: 16.53,
    fibreG: 0,
  },
  'water-chestnut': {
    name: 'Water chestnut (singhara)',
    ndb: '',
    usda: '',
    ifct: 'F016 Water Chestnut',
    water: 73.34,
    kcal: 102,
    proteinG: 0.86,
    fatG: 0.37,
    carbsG: 24.48,
    fibreG: 3.02,
  },
  tindora: {
    name: 'Ivy gourd (tindora, kundru)',
    ndb: '',
    usda: '',
    ifct: 'D054 Kovai, big',
    water: 92.78,
    kcal: 23,
    proteinG: 1.39,
    fatG: 0.24,
    carbsG: 5.01,
    fibreG: 3,
  },
  parwal: {
    name: 'Pointed gourd (parwal)',
    ndb: '',
    usda: '',
    ifct: 'D060 Parwar',
    water: 91.57,
    kcal: 29,
    proteinG: 1.4,
    fatG: 0.3,
    carbsG: 6.15,
    fibreG: 2.61,
  },
  gawar: {
    name: 'Cluster beans (gawar)',
    ndb: '',
    usda: '',
    ifct: 'D039 Cluster beans',
    water: 84.65,
    kcal: 50,
    proteinG: 3.55,
    fatG: 0.37,
    carbsG: 9.74,
    fibreG: 4.83,
  },
  'raw-jackfruit': {
    name: 'Raw jackfruit (kathal)',
    ndb: '',
    usda: '',
    ifct: 'D051 Jack fruit, raw',
    water: 85.52,
    kcal: 42,
    proteinG: 1.98,
    fatG: 0.35,
    carbsG: 11.17,
    fibreG: 7.69,
  },
  'jackfruit-seed': {
    name: 'Jackfruit seeds',
    ndb: '',
    usda: '',
    ifct: 'D052 Jack fruit, seed, mature',
    water: 72.32,
    kcal: 94,
    proteinG: 5.79,
    fatG: 0.44,
    carbsG: 20.44,
    fibreG: 8.63,
  },
  'banana-flower': {
    name: 'Banana flower',
    ndb: '',
    usda: '',
    ifct: 'D062 Plantain, flower',
    water: 89.14,
    kcal: 32,
    proteinG: 1.47,
    fatG: 0.63,
    carbsG: 7.4,
    fibreG: 5.25,
  },
  'raw-banana': {
    name: 'Raw banana',
    ndb: '',
    usda: '',
    ifct: 'D063 Plantain, green',
    water: 76.15,
    kcal: 87,
    proteinG: 1.18,
    fatG: 0.23,
    carbsG: 21.18,
    fibreG: 3.6,
  },
  'banana-stem': {
    name: 'Banana stem',
    ndb: '',
    usda: '',
    ifct: 'D064 Plantain, stem',
    water: 87.53,
    kcal: 44,
    proteinG: 0.35,
    fatG: 0.16,
    carbsG: 10.76,
    fibreG: 2.12,
  },
  bathua: {
    name: 'Bathua leaves',
    ndb: '',
    usda: '',
    ifct: 'C008 Bathua leaves',
    water: 88.77,
    kcal: 36,
    proteinG: 2.5,
    fatG: 0.44,
    carbsG: 6.57,
    fibreG: 4.01,
  },
  'methi-leaves': {
    name: 'Fenugreek leaves (methi)',
    ndb: '',
    usda: '',
    ifct: 'C020 Fenugreek leaves',
    water: 86.73,
    kcal: 44,
    proteinG: 3.68,
    fatG: 0.83,
    carbsG: 7.07,
    fibreG: 4.9,
  },
  gongura: {
    name: 'Gongura (gogu) leaves',
    ndb: '',
    usda: '',
    ifct: 'C022 Gogu leaves, green',
    water: 87.42,
    kcal: 46,
    proteinG: 1.86,
    fatG: 1.09,
    carbsG: 8.65,
    fibreG: 4.59,
  },
  'tapioca-root': {
    name: 'Tapioca root (kappa)',
    ndb: '',
    usda: '',
    ifct: 'F015 Tapioca',
    water: 75.23,
    kcal: 89,
    proteinG: 1.03,
    fatG: 0.2,
    carbsG: 22.42,
    fibreG: 4.61,
  },
  tinda: {
    name: 'Tinda (apple gourd)',
    ndb: '',
    usda: '',
    ifct: 'D073 Tinda, tender',
    water: 94.41,
    kcal: 18,
    proteinG: 1.02,
    fatG: 0.17,
    carbsG: 3.9,
    fibreG: 2,
  },
  'chow-chow': {
    name: 'Chow chow (chayote)',
    ndb: '',
    usda: '',
    ifct: 'D038 Cho-cho-marrow',
    water: 93.78,
    kcal: 22,
    proteinG: 0.66,
    fatG: 0.15,
    carbsG: 5.02,
    fibreG: 1.55,
  },
  colocasia: {
    name: 'Colocasia (arbi)',
    ndb: '',
    usda: '',
    ifct: 'F004 Colocasia',
    water: 73.49,
    kcal: 95,
    proteinG: 3.31,
    fatG: 0.17,
    carbsG: 21.07,
    fibreG: 3.22,
  },
  'colocasia-leaves': {
    name: 'Colocasia leaves (arbi patta)',
    ndb: '',
    usda: '',
    ifct: 'C018 Colocasia leaves, green',
    water: 83.61,
    kcal: 55,
    proteinG: 3.42,
    fatG: 1.38,
    carbsG: 9.29,
    fibreG: 5.6,
  },
  drumstick: {
    name: 'Drumstick (sahjan)',
    ndb: '',
    usda: '',
    ifct: 'D046 Drumstick',
    water: 85.39,
    kcal: 43,
    proteinG: 2.62,
    fatG: 0.12,
    carbsG: 10.59,
    fibreG: 6.83,
  },
  'drumstick-leaves': {
    name: 'Drumstick leaves (moringa)',
    ndb: '',
    usda: '',
    ifct: 'C019 Drumstick leaves',
    water: 75.65,
    kcal: 84,
    proteinG: 6.41,
    fatG: 1.64,
    carbsG: 13.83,
    fibreG: 8.21,
  },
  yam: {
    name: 'Elephant foot yam (suran)',
    ndb: '',
    usda: '',
    ifct: 'F017 Yam, elephant',
    water: 74.39,
    kcal: 93,
    proteinG: 2.56,
    fatG: 0.14,
    carbsG: 21.63,
    fibreG: 4.17,
  },
  'snake-gourd': {
    name: 'Snake gourd (chichinda)',
    ndb: '',
    usda: '',
    ifct: 'D070 Snake gourd, long, pale green',
    water: 94.81,
    kcal: 17,
    proteinG: 0.98,
    fatG: 0.25,
    carbsG: 3.54,
    fibreG: 2.27,
  },
  'raw-mango': {
    name: 'Raw mango (kairi)',
    ndb: '',
    usda: '',
    ifct: 'D057 Mango, green, raw',
    water: 85.14,
    kcal: 55,
    proteinG: 0.69,
    fatG: 0.08,
    carbsG: 13.6,
    fibreG: 3.01,
  },
  'raw-papaya': {
    name: 'Raw papaya',
    ndb: '',
    usda: '',
    ifct: 'D059 Papaya, raw',
    water: 92.04,
    kcal: 28,
    proteinG: 0.5,
    fatG: 0.23,
    carbsG: 6.68,
    fibreG: 2.28,
  },
  amla: {
    name: 'Amla (Indian gooseberry)',
    ndb: '',
    usda: '',
    ifct: 'E021 Goosberry',
    water: 87.02,
    kcal: 39,
    proteinG: 0.34,
    fatG: 0.16,
    carbsG: 12.14,
    fibreG: 7.75,
  },
  bael: {
    name: 'Bael fruit',
    ndb: '',
    usda: '',
    ifct: 'E008 Bael fruit',
    water: 61.36,
    kcal: 149,
    proteinG: 2.63,
    fatG: 0.57,
    carbsG: 34.52,
    fibreG: 6.31,
  },
  jamun: {
    name: 'Jamun',
    ndb: '',
    usda: '',
    ifct: 'E031 Jambu fruit, ripe',
    water: 83.33,
    kcal: 62,
    proteinG: 0.82,
    fatG: 0.17,
    carbsG: 15.37,
    fibreG: 3.07,
  },
  phalsa: {
    name: 'Phalsa',
    ndb: '',
    usda: '',
    ifct: 'E052 Phalsa',
    water: 77.48,
    kcal: 81,
    proteinG: 1.66,
    fatG: 0.14,
    carbsG: 19.63,
    fibreG: 4.54,
  },
  'betel-leaf': {
    name: 'Betel leaf (paan)',
    ndb: '',
    usda: '',
    ifct: 'C010 Betel leaves, big (kolkata)',
    water: 84.93,
    kcal: 53,
    proteinG: 2.51,
    fatG: 0.75,
    carbsG: 9.49,
    fibreG: 2.12,
  },
  mint: {
    name: 'Mint leaves (pudina)',
    ndb: '',
    usda: '',
    ifct: 'G016 Mint leaves',
    water: 84.24,
    kcal: 49,
    proteinG: 4.66,
    fatG: 0.65,
    carbsG: 8.28,
    fibreG: 5.89,
  },
  'coconut-water-ifct': {
    name: 'Tender coconut water, IFCT',
    ndb: '',
    usda: '',
    ifct: 'K002 Coconut Water',
    water: 95.77,
    kcal: 15,
    proteinG: 0.26,
    fatG: 0.16,
    carbsG: 3.16,
    fibreG: 0,
  },
  'sugarcane-juice': {
    name: 'Sugarcane juice',
    ndb: '',
    usda: '',
    ifct: 'I002 Sugarcane, juice',
    water: 85.54,
    kcal: 59,
    proteinG: 0.16,
    fatG: 0.4,
    carbsG: 13.67,
    fibreG: 0.56,
  },
  toddy: {
    name: 'Toddy (kallu)',
    ndb: '',
    usda: '',
    ifct: 'K001 Toddy',
    water: 93.86,
    kcal: 24,
    proteinG: 0.18,
    fatG: 0.03,
    carbsG: 5.72,
    fibreG: 0,
  },
  'bombay-duck': {
    name: 'Bombay duck (bombil)',
    ndb: '',
    usda: '',
    ifct: 'P007 Bombay duck',
    water: 83.24,
    kcal: 69,
    proteinG: 13.53,
    fatG: 1.03,
    carbsG: 0,
    fibreG: 0,
  },
  mackerel: {
    name: 'Indian mackerel (bangda, ayala)',
    ndb: '',
    usda: '',
    ifct: 'P034 Mackerel',
    water: 74.55,
    kcal: 101,
    proteinG: 21.51,
    fatG: 1.53,
    carbsG: 0,
    fibreG: 0,
  },
  sardine: {
    name: 'Sardine (mathi, tarli)',
    ndb: '',
    usda: '',
    ifct: 'P071 Sardine',
    water: 72.29,
    kcal: 152,
    proteinG: 17.91,
    fatG: 8.99,
    carbsG: 0,
    fibreG: 0,
  },
  pomfret: {
    name: 'Pomfret, white (paplet)',
    ndb: '',
    usda: '',
    ifct: 'P057 Pomfret, white',
    water: 75.91,
    kcal: 123,
    proteinG: 19.02,
    fatG: 5.12,
    carbsG: 0,
    fibreG: 0,
  },
  'seer-fish': {
    name: 'Seer fish (surmai, vanjaram)',
    ndb: '',
    usda: '',
    ifct: 'P087 Vanjaram',
    water: 72.3,
    kcal: 136,
    proteinG: 22.28,
    fatG: 5.18,
    carbsG: 0,
    fibreG: 0,
  },
  hilsa: {
    name: 'Hilsa (ilish)',
    ndb: '',
    usda: '',
    ifct: 'P017 Hilsa',
    water: 60.09,
    kcal: 259,
    proteinG: 21.8,
    fatG: 18.49,
    carbsG: 0,
    fibreG: 0,
  },
  catla: {
    name: 'Catla (katla)',
    ndb: '',
    usda: '',
    ifct: 'S002 Catla',
    water: 78.43,
    kcal: 94,
    proteinG: 17.94,
    fatG: 2.15,
    carbsG: 0,
    fibreG: 0,
  },
  rohu: {
    name: 'Rohu',
    ndb: '',
    usda: '',
    ifct: 'S006 Rohu',
    water: 76.34,
    kcal: 102,
    proteinG: 19.71,
    fatG: 2.39,
    carbsG: 0,
    fibreG: 0,
  },
  bhetki: {
    name: 'Bhetki (barramundi)',
    ndb: '',
    usda: '',
    ifct: 'P005 Betki',
    water: 82.52,
    kcal: 68,
    proteinG: 15.28,
    fatG: 0.29,
    carbsG: 0,
    fibreG: 0,
  },
  karimeen: {
    name: 'Pearl spot (karimeen)',
    ndb: '',
    usda: '',
    ifct: 'P026 Karimeen',
    water: 78.66,
    kcal: 92,
    proteinG: 19.68,
    fatG: 1.38,
    carbsG: 0,
    fibreG: 0,
  },
  'tuna-fresh': {
    name: 'Tuna, fresh',
    ndb: '',
    usda: '',
    ifct: 'P084 Tuna',
    water: 72.12,
    kcal: 112,
    proteinG: 24.5,
    fatG: 1.44,
    carbsG: 0,
    fibreG: 0,
  },
  anchovy: {
    name: 'Anchovy (netholi, kozhuva)',
    ndb: '',
    usda: '',
    ifct: 'P003 Anchovy',
    water: 77.77,
    kcal: 88,
    proteinG: 19.88,
    fatG: 0.78,
    carbsG: 0,
    fibreG: 0,
  },
  basa: {
    name: 'Basa (pangas)',
    ndb: '',
    usda: '',
    ifct: 'S005 Pangas',
    water: 68.5,
    kcal: 204,
    proteinG: 17.12,
    fatG: 16.77,
    carbsG: 0,
    fibreG: 0,
  },
  tilapia: {
    name: 'Tilapia',
    ndb: '',
    usda: '',
    ifct: 'P083 Tilapia',
    water: 79.57,
    kcal: 83,
    proteinG: 18.48,
    fatG: 1.08,
    carbsG: 0,
    fibreG: 0,
  },
  catfish: {
    name: 'Catfish (magur)',
    ndb: '',
    usda: '',
    ifct: 'S001 Cat fish',
    water: 77.23,
    kcal: 124,
    proteinG: 15.86,
    fatG: 6.24,
    carbsG: 0,
    fibreG: 0,
  },
  mullet: {
    name: 'Mullet',
    ndb: '',
    usda: '',
    ifct: 'P039 Mullet',
    water: 76.12,
    kcal: 94,
    proteinG: 20.23,
    fatG: 1.32,
    carbsG: 0,
    fibreG: 0,
  },
  'red-snapper': {
    name: 'Red snapper (rane)',
    ndb: '',
    usda: '',
    ifct: 'P065 Red snapper',
    water: 76.28,
    kcal: 104,
    proteinG: 22.79,
    fatG: 1.34,
    carbsG: 0,
    fibreG: 0,
  },
  crab: {
    name: 'Crab',
    ndb: '',
    usda: '',
    ifct: 'Q002 Crab, sea',
    water: 79.67,
    kcal: 68,
    proteinG: 15.36,
    fatG: 0.6,
    carbsG: 0,
    fibreG: 0,
  },
  lobster: {
    name: 'Lobster',
    ndb: '',
    usda: '',
    ifct: 'Q004 Lobster, king size',
    water: 77.77,
    kcal: 90,
    proteinG: 18.54,
    fatG: 0.78,
    carbsG: 0,
    fibreG: 0,
  },
  squid: {
    name: 'Squid (calamari)',
    ndb: '',
    usda: '',
    ifct: 'R007 Squid, white, small',
    water: 79.38,
    kcal: 84,
    proteinG: 17.41,
    fatG: 1.15,
    carbsG: 0,
    fibreG: 0,
  },
  clams: {
    name: 'Clams (tisryo, kakka)',
    ndb: '',
    usda: '',
    ifct: 'R002 Clam, white shell, ribbed',
    water: 80.27,
    kcal: 60,
    proteinG: 11.82,
    fatG: 1.34,
    carbsG: 0,
    fibreG: 0,
  },
  oyster: {
    name: 'Oyster',
    ndb: '',
    usda: '',
    ifct: 'Q006 Oyster',
    water: 82.5,
    kcal: 60,
    proteinG: 9.51,
    fatG: 2.44,
    carbsG: 0,
    fibreG: 0,
  },
  'prawns-small': {
    name: 'Prawns, small (river)',
    ndb: '',
    usda: '',
    ifct: 'S009 Prawns, small',
    water: 82.58,
    kcal: 71,
    proteinG: 13.07,
    fatG: 0.78,
    carbsG: 0,
    fibreG: 0,
  },
  beef: {
    name: 'Beef',
    ndb: '',
    usda: '',
    ifct: 'O025 Beef, shoulder',
    water: 63.84,
    kcal: 212,
    proteinG: 20.56,
    fatG: 14.59,
    carbsG: 0,
    fibreG: 0,
    note: 'Shoulder, the usual curry cut.',
  },
  pork: {
    name: 'Pork',
    ndb: '',
    usda: '',
    ifct: 'O048 Pork, shoulder',
    water: 62.92,
    kcal: 237,
    proteinG: 17.41,
    fatG: 18.83,
    carbsG: 0,
    fibreG: 0,
    note: 'Shoulder, the usual curry cut.',
  },
  duck: {
    name: 'Duck',
    ndb: '',
    usda: '',
    ifct: 'N011 Duck, meat, with skin',
    water: 73.49,
    kcal: 131,
    proteinG: 19.07,
    fatG: 6.03,
    carbsG: 0,
    fibreG: 0,
  },
  quail: {
    name: 'Quail',
    ndb: '',
    usda: '',
    ifct: 'N015 Quail, meat, skinless',
    water: 71.58,
    kcal: 138,
    proteinG: 20.92,
    fatG: 5.95,
    carbsG: 0,
    fibreG: 0,
  },
  turkey: {
    name: 'Turkey',
    ndb: '',
    usda: '',
    ifct: 'N018 Turkey, breast, with skin',
    water: 68.44,
    kcal: 160,
    proteinG: 21.96,
    fatG: 8.04,
    carbsG: 0,
    fibreG: 0,
  },
  rabbit: {
    name: 'Rabbit',
    ndb: '',
    usda: '',
    ifct: 'O063 Rabbit, leg',
    water: 70.33,
    kcal: 140,
    proteinG: 21.31,
    fatG: 5.99,
    carbsG: 0,
    fibreG: 0,
  },
  'goat-liver': {
    name: 'Mutton liver (kaleji)',
    ndb: '',
    usda: '',
    ifct: 'O008 Goat, liver',
    water: 73.37,
    kcal: 126,
    proteinG: 20.32,
    fatG: 4.88,
    carbsG: 0,
    fibreG: 0,
  },
  'goat-brain': {
    name: 'Mutton brain (bheja)',
    ndb: '',
    usda: '',
    ifct: 'O004 Goat, brain',
    water: 76.74,
    kcal: 127,
    proteinG: 13.82,
    fatG: 8.06,
    carbsG: 0,
    fibreG: 0,
  },
  'goat-tripe': {
    name: 'Mutton tripe (boti)',
    ndb: '',
    usda: '',
    ifct: 'O009 Goat, tripe',
    water: 80.94,
    kcal: 92,
    proteinG: 15.36,
    fatG: 3.36,
    carbsG: 0,
    fibreG: 0,
  },
  'chicken-liver': {
    name: 'Chicken liver',
    ndb: '',
    usda: '',
    ifct: 'N005 Poultry, chicken, liver',
    water: 73.2,
    kcal: 124,
    proteinG: 21.57,
    fatG: 4.08,
    carbsG: 0,
    fibreG: 0,
  },
  'chicken-gizzard': {
    name: 'Chicken gizzard',
    ndb: '',
    usda: '',
    ifct: 'N006 Poultry, chicken, gizzard',
    water: 78.05,
    kcal: 92,
    proteinG: 18.22,
    fatG: 2.07,
    carbsG: 0,
    fibreG: 0,
  },
  'country-chicken': {
    name: 'Country chicken (desi murgi)',
    ndb: '',
    usda: '',
    ifct: 'N009 Country hen, breast, with skin',
    water: 66.53,
    kcal: 180,
    proteinG: 22.08,
    fatG: 10.2,
    carbsG: 0,
    fibreG: 0,
    note: 'Country hen breast with skin.',
  },
  water: {
    name: 'Water',
    ndb: '',
    usda: 'Water',
    water: 100,
    kcal: 0,
    proteinG: 0,
    fatG: 0,
    carbsG: 0,
    fibreG: 0,
  },
} as const satisfies Record<string, Ingredient>;

export type IngredientId = keyof typeof INGREDIENTS;
